export const getColorSlug = function (val: string) {
  const url = val
    ?.replace(/[()]/g, "") 
    ?.split(" ")
    .join("-")
    .toLowerCase();

  return url;
};